// Copyright 2026. WebPros International GmbH. All rights reserved.

import React from 'react';
import styled from 'styled-components';
import {
    Grid as UIGrid,
    GridProps,
} from '@plesk/ui-library';

export const Grid = styled(UIGrid)`
  max-width: 50%;

  @media (max-width: 1800px) {
    max-width: 60%;
  }

  @media (max-width: 1400px) {
    max-width: 80%;
  }

  @media (max-width: 1200px) {
    max-width: 100%;
  }
` as unknown as React.ComponentType<GridProps>;

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100%;

    & > *:last-child {
        flex: 1;
    }
`;

export const ItemText = styled.div`
    margin-block-start: .75rem;
`;
